import React, { Component } from "react"
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner } from "react-bootstrap";
import moment from "moment";
import { withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import CardLessDataTableWithOutSearch from '../../../../components/datatables/CardLessDataTableWithOutSearch';
import PermissionDetailsModal from '../../../studentPermission/PermissionDetailsModal';



const FETCH_PARENT_PERMISSION = gql`
query($institute_id: Int!) {
  getParentsPermissionDetails(institute_id: $institute_id) {
    class_id
    exam_id
    branch_id
    section_id
    class_name
    exam_name
    branch_name
    section_name
    permission_id
    student_name
    roll_no
    student_mobile
    request_date
    from_datetime
    to_datetime
    receiver_name
    receiver_mobile
    request_message
    receiver_image_path
    parent_name
    parent_mobile
    permission_status
    comments
    approved_time
    approved_by
    outtime
    outtime_image_path
    outtime_inserted_by
    intime
    intime_image_path
    intime_inserted_by
    permission_request_type_id
    request_title
  }
}
`;

const FETCH_PERMISSION_REQUEST_TYPES = gql`
query($id: Int) {
  getPermissionRequestTypes(id: $id) {
    id
    permission_request_type
  }
}
`;



class NAPermissionDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            viewDetailsModal: false,
            loader: 0,
            individualPermissionData: [],
        }
    }

    articlecolumns = [
        {
            dataField: "sl_no",
            text: "Sl No.",
        },
        {
            dataField: "request_date",
            text: "Request Date",
            sort: true,
        },
        {
            dataField: "request_message",
            text: "Comments",
        },
        {
            formatter: this.requestFunc.bind(this),
        },
        {
            dataField: "receiver_name",
            text: "Reciever Name",
        },
        {
            dataField: "receiver_mobile",
            text: "Reciever Mobile",
        },
        {
            dataField: "Status",
            text: "Status",
            formatter: this.performanceFunc.bind(this),
        },
        {
            formatter: this.iconFunc.bind(this),
        },
    ];


    performanceFunc(val, row) {
        return (<>
            <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.setState({ viewDetailsModal: true, individualPermissionData: row.individualPermissionData })}>
                <Button variant="link" name="view" className="text-theme">
                <i className="fas fa-eye" />
                </Button>
            </div>
        </>)
    }


    iconFunc(val, row) {
        const individualPermissionData = row.individualPermissionData;
        if (individualPermissionData) {
            if (individualPermissionData.permission_status == null) {
                return <i className="fas fa-clock text-warning icon-large" />;
            } else if (individualPermissionData.permission_status == "1") {
                return <i className="fas fa-check-circle text-success icon-large" />;
            } else if (individualPermissionData.permission_status == "2") {
                return <i className="fas fa-times text-danger icon-large" />;
            } else {
                return ""
            }
        } else {
            return null;
        }
    }

    requestFunc(val, row) {
        const individualPermissionData = row.individualPermissionData;
        console.log("individual", individualPermissionData,)
        if (individualPermissionData.permission_request_type_id == 2) {
            return <p>Requested By College <i className="fas fa-star text-success star" /></p>
        }
    }


    render() {
        // console.log("hhh", this.props.stateData.studentData)
        // console.log("hhh",parentPermission.getParentsPermissionDetails )

        const parentPermission = this.props.parentPermission;
        const loading1 = parentPermission.loading;
        const error1 = parentPermission.error;

        const permissionRequest = this.props.permissionRequest;
        const loading2 = permissionRequest.loading;
        const error2 = permissionRequest.error;

        if (loading1 || loading2) return null;


        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }
        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }

        // console.log("hari", parentPermission.getParentsPermissionDetails)

        let studentData = this.props.stateData.studentData

        let filter_data = parentPermission.getParentsPermissionDetails.filter((item) => item.student_mobile == studentData.contact_no)

        console.log("hbbbb", filter_data)

        let studentDetails = []

        filter_data.map((item, index) => {
            console.log("item", item)
            const requestTitle = item.request_title || "";
            const requestMessage = item.request_message || "";
            
            let requestMessagePart = requestMessage;
            
            if (requestMessage && requestTitle) {
              requestMessagePart = `${requestTitle} - ${requestMessage}`;
            } else {
              requestMessagePart = requestTitle || requestMessage;
            }
            const newObj = {
                sl_no: index + 1,
                receiver_name: item.receiver_name,
                receiver_mobile: item.receiver_mobile,
                request_message: requestMessagePart,
                 request_date: moment.unix(item.request_date).format("DD-MM-YYYY"),
                individualPermissionData: item,

            }

            studentDetails.push(newObj);

        })

        let overallrequest = [];
        let totalrequest = [];
        let totalaccept = [];
        let totaldecline = [];


        let students = parentPermission.getParentsPermissionDetails

        overallrequest = parentPermission.getParentsPermissionDetails.length
        totalrequest = students.filter((item) => item.permission_status == null).length
        totalaccept = students.filter((item1) => item1.permission_status == "1").length
        totaldecline = students.filter((item2) => item2.permission_status == "2").length

        console.log("bade", overallrequest)


        return (

            <Container fluid>
                <Row>
                    <Col>
                        {
                            this.state.loader == 1 ? (
                                <span className="spinner-border spinner-border-sm text-center spinner-alignment"></span>
                            ) : ""
                        }

                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col sm={12}>

                        {
                            filter_data.length > 0 ? (

                                <CardLessDataTableWithOutSearch
                                    parentData={studentDetails}
                                    particlecolumns={this.articlecolumns}
                                    name="attendance"
                                />

                            ) : (
                                <Col ls={12} md={12} sm={12}>
                                    <h4 className='mt-3 text-center'>No data available</h4>
                                </Col>
                            )
                        }

                    </Col>
                </Row>
                <PermissionDetailsModal
                    stateData={this.state}
                    show={this.state.viewDetailsModal}
                    onHide={() => this.setState({ viewDetailsModal: false })}
                />
            </Container>

        )
    }
}

export default withRouter(
    compose(
        graphql(FETCH_PARENT_PERMISSION, {
            options: (props) => ({
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                },
                fetchPolicy: "cache-and-network",
            }),
            name: "parentPermission",
        }),
        graphql(FETCH_PERMISSION_REQUEST_TYPES, {
            options: (props) => ({
                variables: {
                    id: parseInt(Cookies.get("institutionid")),
                },
                fetchPolicy: "cache-and-network",
            }),
            name: "permissionRequest",
        }),
    )
        (NAPermissionDetails));